<script>
export default {
  props: {
    items: Array,
  },
};
</script>
<template>
  <v-list v-if="items.length">
    <v-subheader>ПОЛЕЗНЫЕ ССЫЛКИ</v-subheader>
    <v-list-item
      v-for="(item, idx) in items"
      :key="idx"
      target="_blank"
      :href="item.link"
    >
      <v-list-item-action v-if="item.icon">
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-title>{{ item.label }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
<style lang="scss">

</style>
